classnames = require('classnames')
component = React.createElement
dom = React.DOM
{ Component, PropTypes } = React
TextareaAutosize = require('react-textarea-autosize').default
_debounce = require('lodash-es/debounce').default
_assign = require('lodash-es/assign').default
{ moveCursorToEnd } = require('../../helpers/InputHelpers')

require('./style.styl')

class Input extends Component
  @statics: {
    inputNodeRef: 'input'
  }

  @propTypes: {
    isValid: PropTypes.bool.isRequired
    valueLink: PropTypes.shape({
      value: PropTypes.any
    })
    autoFocus: PropTypes.bool
    debounceTime: PropTypes.number
    disabled: PropTypes.bool
    errorOverride: PropTypes.bool
    label: PropTypes.node
    errorLabel: PropTypes.node
    helperLabel: PropTypes.node
    readOnly: PropTypes.bool
    childrenFirst: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
    ])
    size: PropTypes.oneOf(['small', 'medium', 'large'])
    wrapperProps: PropTypes.object,
  }

  constructor: (props) ->
    @state = {
      isFocused: false
      hasBeenFocused: false
      isValid: true
    }

  componentDidMount: ->
    if @props.autoFocus
      moveCursorToEnd(@inputNode)
    @updateStateFromDOM()
    setTimeout(@updateStateFromDOM, 400)

  componentWillUnmount: ->
    @debounced?.cancel()

  updateStateFromDOM: ->
    return if not (@inputNode? and @inputNode.value)
    @props.valueLink?.requestChange?(@inputNode.value)

  debounceSetValid: ->
    _debounce(@setValid, @props.debounceTime)

  isChildrenFirst: ->
    @props.childrenFirst is true or @props.childrenFirst is 'true'

  isEditable: ->
    not (@props.readOnly or @props.disabled)

  setValid: ->
    @setState({ isValid: @props.isValid })

  componentWillReceiveProps: (nextProps) ->
    if @isEditable() and nextProps.valueLink?
      if nextProps.valueLink.value isnt @props.valueLink.value
        @onChange()
      if not nextProps.valueLink.value
        @setState({ hasBeenFocused: false })

  showErrorAttention: ->
    if @isEditable()
      @props.errorOverride or
        (not @state.isFocused and @state.hasBeenFocused and not @props.isValid)

  showErrorLabel: ->
    if (@state.isFocused or @props.errorOverride) and @props.errorLabel
      if @props.debounceTime
        return not @state.isValid
      else
        return not @props.isValid

  showInvalidLabel: ->
    (@props.errorOverride or (not @state.isFocused and @state.hasBeenFocused)) and @props.invalidLabel

  onChange: ->
    if @debounced
      @debounced.cancel()

    if @props.debounceTime
      @debounced = @debounceSetValid()
      @setState({ isValid: true }, @debounced())

  render: ->
    showErrorAttention = @showErrorAttention()
    showErrorLabel = @showErrorLabel()
    inputBaseProp = { ref: ((ref) => @inputNode = ref), children: undefined }
    wrapperProps = _assign({}, @props.wrapperProps, {
      className: classnames('input-wrapper', @props.className)
    })
    dom.div wrapperProps,
      dom.label {},
        if @props.label
          dom.div { className: 'dsg-Label--gray' }, @props.label
        dom.div {
            onFocus: @onFocus.bind(@)
            onBlur: @onBlur.bind(@)
            className: classnames('Input', @props.size, {
              error: @isEditable() and showErrorAttention
              active: @state.isFocused
              'read-only': @props.readOnly
            })
          },
          if @props.children and @isChildrenFirst()
            @props.children

          if @props.inputComponent
            component @props.inputComponent, _assign({}, @props, inputBaseProp)
          else if @props.isTextArea
            dom.textarea _assign({}, @props, inputBaseProp)
          else if @props.isTextAreaAutosize
            component TextareaAutosize, _assign({}, @props, inputBaseProp)
          else
            dom.input _assign({}, @props, inputBaseProp)

          if showErrorLabel
            dom.div { className: 'overlay-label error' }, @props.errorLabel
          else if @props.labelOnFocus and @state.isFocused
            dom.div { className: 'overlay-label' }, @props.labelOnFocus

          if @props.children and not @isChildrenFirst()
            @props.children
        if @showInvalidLabel()
          dom.div { className: 'dsg-Label--pink', style: { textTransform: 'none' } }, @props.invalidLabel
        else if @props.helperLabel?
          dom.div { className: 'dsg-Label', style: { textTransform: 'none' } }, @props.helperLabel

  onFocus: ->
    @setState({ isFocused: true })

  onBlur: ->
    @setState( { isFocused: false, hasBeenFocused: true , isValid: @props.isValid } )
    @props.onBlur() if @props.onBlur

module.exports = Input



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/Input/index.coffee